import instance from '@/main'

const urlPrefix = '/external/'


/**
 * Marks the quiz as being started
 * @param {String} slug: The URL slug for the newly created quiz
 */
const startQuiz = async (slug) => {
    let response = await instance.get(`${urlPrefix}take`, { params: {slug} });
    return response;
}

/**
 * Gets the questions and metadata for the current quiz
 * @returns {Number} section_number
 * @returns {Number} number_of_questions
 * @returns {Number} video_link
 * @returns {Array} questions: List of questions. Questions have the following params
 * @returns {String} name: Name of the quiz
 * @returns {String} request_app: Return site (THINK/Dash) for the user on quiz complete
 */
const getQuestions = async() => {
    let response = await instance.get(`${urlPrefix}questions`);
    return response;
}

/**
 * Validate quiz answers on quiz completion
 * @param {Array} answers: List of answers that were chosen for each question
 * @returns {Boolean} passed_quiz: Whether or not the quiz passed
 * @returns {Number} correct_count: Number of correct questions
 * @returns {Number} questions_count: Number of total questions
 */
const updateQuiz = async(answers) => {
    let response = await instance.post(`${urlPrefix}submit`, answers);
    return response;
}

/**
 * Get the number of questions that a user can get wrong
 * @return {Number} response: The number of questions that can be missed
 */
const getIncorrectAllowed = async() => {
    let response = instance.get(`${urlPrefix}incorrect`);
    return response;
}

export {
    startQuiz,
    getQuestions,
    updateQuiz,
    getIncorrectAllowed
}